export default __webpack_public_path__ + "static/media/Thailand.7198668f.jpeg";